const firebaseConfig = {
  apiKey: "AIzaSyCJ8P9o7sh-WOcR9UgtRlWgtW-1cazG8nk",
  authDomain: "tour-guider-57b16.firebaseapp.com",
  projectId: "tour-guider-57b16",
  storageBucket: "tour-guider-57b16.appspot.com",
  messagingSenderId: "487889014290",
  appId: "1:487889014290:web:3e87671a1ebb6c8bf912cb"
};

  export default firebaseConfig ;